<template>
  <page-wrapper title="รายการสินค้า" ref="pageEl">
    <div class="sap-mm-po-vender-report">
      <vue-tabs
        class="child-component"
        active-tab-color="#d3d0cf"
        v-model="tabDirect"
      >
        <v-tab title="ซื้อใหม่">
          <appointment-product-waiting-fulfill
            class="mt-3"
            @reloadAppointmentDashboardPage="
              isReloadAppointmentDashboardPage = true
            "
          ></appointment-product-waiting-fulfill>
        </v-tab>
        <v-tab title="เสร็จสิ้น">
          <appointment-dashboard-page
            :isProductPage="true"
            :isReloadAppointmentDashboardPage="isReloadAppointmentDashboardPage"
            @reloadAppointmentDashboardPage="
              isReloadAppointmentDashboardPage = false
            "
          ></appointment-dashboard-page>
        </v-tab>
      </vue-tabs>
    </div>
  </page-wrapper>
</template>

<script>
import PageWrapper from "@/lib/components/PageWrapper";
import AppointmentProductWaitingFulfill from "../components/AppointmentProductWaitingFulfill.vue";
import AppointmentDashboardPage from "./AppointmentDashboardPage.vue";

export default {
  name: 'AppointmentProductDashboardPage',
  components: {
    PageWrapper,
    AppointmentProductWaitingFulfill,
    AppointmentDashboardPage,
  },
  data() {
    return {
      isReloadAppointmentDashboardPage: false,
      tabDirect: null,
    };
  },
  created() {
    if (this.$route.query.tab && this.$route.query.tab !== "ซื้อใหม่") {
      this.tabDirect = this.$route.query.tab;
    }
  },
  watch: {
    tabDirect(newValue) {
      if (newValue && newValue !== this.$route.query.tab) {
        const route = {
          name: this.$route.name,
          query: { ...this.$route.query, tab: newValue },
        };

        this.$router.push(route);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.sap-mm-po-vender-report {
  padding-left: 30px;
  padding-top: 30px;
  font-size: 20px;
}
</style>


// WEBPACK FOOTER //
// src/features/subscriptions/modules/appointments/pages/AppointmentProductDashboardPage.vue